import { createSliceSaga } from "../saga-helper";

import { call, put } from "redux-saga/effects";
import { ClientReducerAction } from "./slice";
import {
  GetClientDropDownListService,
  SetSelectedClientService,
  SetSelectedClientsService,
} from "../../services/ClientDropDown";
import { AxiosResponse } from "axios";

function* fetchClientsAndSetAuth(action: { payload: any }) {
  const { isLogin, resolve } = action.payload || {}; // Extract promise resolver
  try {
    yield put(ClientReducerAction.setIsLoading(true));

    // Fetch Clients
    const { data, status }: AxiosResponse = yield call(
      GetClientDropDownListService
    );

    if (status === 200) {
      const clientList = data?.accounts || [];
      yield put(ClientReducerAction.setClientList(clientList));

      if (clientList.length > 0) {
        let selectedClientId = localStorage.getItem("selectedClientId");
        let selectedClientIdsArray: number[] | null = null;

        const multiStored = localStorage.getItem("selectedClientIds");
        if (multiStored) {
          try {
            const parsed = JSON.parse(multiStored);
            if (Array.isArray(parsed) && parsed.length > 0) {
              selectedClientIdsArray = parsed.map((id: any) => Number(id));
            }
          } catch (e) {
            selectedClientIdsArray = null;
          }
        }

        if (!selectedClientIdsArray && !selectedClientId) {
          const lastActiveAccount = clientList.find(
            (client: any) => !!client?.active
          );
          selectedClientId = lastActiveAccount?.id || clientList[0]?.id;
          if (selectedClientId) {
            localStorage.setItem("selectedClientId", String(selectedClientId));
          }
        }

        // If multi selection exists, use multi api
        if (selectedClientIdsArray && selectedClientIdsArray.length > 0) {
          const alreadySetMulti = localStorage.getItem("selectedClientIds");
          if (!alreadySetMulti || isLogin) {
            // call multiple accounts API (string array)
            yield call(
              SetSelectedClientsService,
              selectedClientIdsArray.map((id) => String(id))
            );
          }
          // update redux with array of numbers
          yield put(
            ClientReducerAction.setClientSelected(selectedClientIdsArray)
          );
        } else if (selectedClientId) {
          // single-select flow (legacy)
          const alreadySet = localStorage.getItem("selectedClientId");
          if (!alreadySet || isLogin) {
            yield call(SetSelectedClientService, String(selectedClientId));
          }
          yield put(
            ClientReducerAction.setClientSelected(String(selectedClientId))
          );
        }
      }
    }
  } catch (error) {
    console.error("Error in fetchClientsAndSetAuth:", error);
  } finally {
    yield put(ClientReducerAction.setIsLoading(false));
    if (resolve) resolve();
  }
}

const saga = createSliceSaga({
  name: "client-saga-state",
  caseSagas: {
    *fetchClientsAndSetAuth(action: { payload: any }) {
      yield call(fetchClientsAndSetAuth, action);
    },
    *fetchClien3ts() {
      try {
        yield put(ClientReducerAction.setIsLoading(true));
        const { data, status }: AxiosResponse = yield call(
          GetClientDropDownListService
        );
        if (status === 200) {
          const clientList = data?.accounts || [];
          yield put(ClientReducerAction.setClientList(clientList));
          return clientList;
        }
      } catch (error) {
        console.error("Error fetching clients:", error);
      } finally {
        yield put(ClientReducerAction.setIsLoading(false));
      }
    },
    *setClient(action: {
      payload: { clientId: string; resolve?: () => void };
    }) {
      try {
        yield put(ClientReducerAction.setIsLoading(true));

        const { status }: AxiosResponse = yield call(
          SetSelectedClientService,
          action.payload.clientId
        );

        if (status === 200) {
          yield put(
            ClientReducerAction.setClientSelected(action.payload.clientId)
          );
          // persist legacy single key and clear multi key if any
          try {
            localStorage.setItem(
              "selectedClientId",
              String(action.payload.clientId)
            );
            localStorage.removeItem("selectedClientIds");
          } catch (e) {
            // ignore
          }
        } else {
          yield put(ClientReducerAction.setIsLoading(false));
        }
      } catch (error) {
        console.error("Error setting selected client:", error);
      } finally {
        yield put(ClientReducerAction.setIsLoading(false));

        // Call resolve() to notify caller that saga is done
        if (action.payload.resolve) {
          action.payload.resolve();
        }
      }
    },

    // NEW: Multi-select setter
    *setClients(action: {
      payload: { clientIds: string[]; resolve?: () => void };
    }) {
      try {
        yield put(ClientReducerAction.setIsLoading(true));

        const { clientIds } = action.payload || {};

        if (Array.isArray(clientIds)) {
          // call multi-select service
          const { status }: AxiosResponse = yield call(
            SetSelectedClientsService,
            clientIds
          );

          if (status === 200) {
            // Store numeric ids array in redux
            yield put(
              ClientReducerAction.setClientSelected(
                clientIds.map((id) => Number(id))
              )
            );

            // persist multi key and remove legacy single key
            try {
              localStorage.setItem(
                "selectedClientIds",
                JSON.stringify(clientIds)
              );
              localStorage.removeItem("selectedClientId");
            } catch (e) {
              // ignore
            }
          } else {
            // API returned non-200
            yield put(ClientReducerAction.setIsLoading(false));
          }
        } else {
          console.warn("setClients called without clientIds array");
        }
      } catch (error) {
        console.error("Error setting multiple selected clients:", error);
      } finally {
        yield put(ClientReducerAction.setIsLoading(false));
        if (action.payload?.resolve) {
          action.payload.resolve();
        }
      }
    },
  },
  sagaType: "takeEvery",
});

export const {
  actions: ClientSagaAction,
  saga: ClientSaga,
  name: ClientSagaName,
} = saga;
